import { Directive, ElementRef, Input } from '@angular/core';
import { UtilsService } from './utils.service';

@Directive({
  selector: '[canWrite]'
})
export class CanWriteDirective {

  @Input('canWrite') permission: string = '';

  constructor(private elementRef: ElementRef, private utilsService: UtilsService) { }

  async ngOnInit() {

    if (this.utilsService.canWrite(this.permission)) {
      return;
    }

    this.hideElement();

  }

  hideElement() {
    this.elementRef.nativeElement.parentElement.removeChild(this.elementRef.nativeElement);
  }

}
